const apiConfig = {
  baseUrl: "https://api.themoviedb.org/3/",
  apiKey: "9717983256e2db8dca655c24bdffe7d8",
  originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
  w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500/${imgPath}`,
};

export default apiConfig;
